"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const use_department_1 = __importDefault(require("./use-department"));
const ocm_object_1 = require("@ocm/services/ocm-object");
const mostSuggestedItems = (0, vue_1.ref)({
    headline: "",
    mostSearchItems: [],
});
const hasMostSuggestedItems = (0, vue_1.computed)(() => mostSuggestedItems.value.mostSearchItems.length > 0);
const { department } = (0, use_department_1.default)();
const loadSuggestions = async () => {
    const url = department.value !== ""
        ? `${ocm_object_1.contextPath}/rest/search/config/?department=${department.value}`
        : `${ocm_object_1.contextPath}/rest/search/config/`;
    try {
        const response = await fetch(url);
        if (!response.ok)
            throw new Error("Most Suggested request failed");
        const data = await response.json();
        mostSuggestedItems.value = data;
    }
    catch (err) {
        console.error(err);
    }
};
function useMostSuggestedRequest() {
    return {
        mostSuggestedItems,
        hasMostSuggestedItems,
        loadSuggestions,
    };
}
exports.default = useMostSuggestedRequest;
